import {STATES} from 'common/domain/states';

class PeriodListLinkController {
  constructor($state) {
    'ngInject';
    this.state = $state;
  }

  goToPeriodListMobile() {
    if (this.isInception()) {
      return this.onClickPeriodMobileListLink();
    }

    this.state.go(STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE, {dateToLoad: this.dateToLoad});
  }

  isInception() {
    return !!this.userInceptionId;
  }
}

export default PeriodListLinkController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/periodListLink/periodListLink.controller.js